exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loading[data-v-479aecc3] {\n  width: 100%;\n  height: 23.5rem;\n}\n", "", {"version":3,"sources":["/app/jenkins/data/workspace/prod-green-town-appStore/src/components/ContentLoader/AppLoader.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;CACjB","file":"AppLoader.vue","sourcesContent":["\n.loading[data-v-479aecc3] {\n  width: 100%;\n  height: 23.5rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-479aecc3","scoped":true,"hasInlineConfig":false}!./node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/ContentLoader/AppLoader.vue
// module id = xmOT
// module chunks = 0